<template>
	<div class="stats"> 
         <div class="row">
            <div class="col">
                <ul class="list-group my-list">
                    <li class="list-group-item text-left" v-for="(stat) of thirdBoxStats" :key="stat.spolecnost" :class="{ isapi: stat.count === 'API' }">
                        <div class="row">
                            <div class="col">
                                {{ stat.spolecnost }}:
                            </div>
                        </div>
                        <div class="row text-right">
                            <div class="col" style="font-weight: bold;">
                                {{ stat.count }}
                            </div>
                        </div>
                             
                    </li>

                </ul>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	name: 'AddUser',

    props: {
		thirdBoxStats: Array,
    },
}
</script>

<style lang="stylus" scoped>

.stats 
    display flex
    flex-direction column

.features-title 
    font-size 24px
    line-height 30px
    text-align center
    border-bottom 1px solid rgb(187, 187, 187)
    padding-top 5px
    padding-bottom 10px
    background-color rgb(31, 142, 246)
    color white

.messages-box 
    overflow-y scroll
    text-align left

.my-list
	max-height 75vh
	min-height 75vh
	overflow-y scroll
	background-color white
	padding 0px

.stats-box 
    display flex
    flex-direction column

.feature-msg 
    border-bottom 1px solid rgb(187, 187, 187)
    margin-top 10px

.isapi
    background-color #b3ff9e

@media (max-width 1000px) 
    .messages-box  
        text-align center
        width 80%
        border-bottom 3px solid gray

</style>



// WEBPACK FOOTER //
// src/components/info_boxes/StatsBox.vue